export const AlarmErrorDetailTablePermision = (role) => {
  if (role === "Admin") {
    return [
      { key: "actions", th: "" },
      { key: "item", th: "Item" },
      { key: "readingDate", th: "Date / Time" },
      { key: "forwardMeasurement", th: "Forward Measurement" },
      { key: "forwardReading", th: "Forward Reading" },
      { key: "reverseMeasurement", th: "Reverse Measurement" },
      { key: "reverseReading", th: "Reverse Reading" },
      { key: "netMeasurement", th: "Net Measurement" },
      { key: "netReading", th: "Net Reading" },
      { key: "flow", th: "Flow" },
      { key: "velocity", th: "Velocity" },
      { key: "loggerSignalValue", th: "Signal Reading" },
      { key: "loggerSignalStrength", th: "Signal Strength" },
      { key: "loggerBatteryValue", th: "Battery Reading" },
      { key: "alarmType", th: "Alarm Type" },
      { key: "alarmCode", th: "Alarm Code" },
      { key: "alarmAction", th: "Alarm Action" },
      { key: "case", th: "Case" },
      { key: "fieldActivity", th: "Field Activity" },
      { key: "acknowledged", th: "Acknowledged" },
    ];
  } else {
    return [
      { key: "actions", th: "" },
      { key: "item", th: "Item" },
      { key: "readingDate", th: "Date / Time" },
      { key: "forwardMeasurement", th: "Forward Measurement" },
      { key: "forwardReading", th: "Forward Reading" },
      { key: "reverseMeasurement", th: "Reverse Measurement" },
      { key: "reverseReading", th: "Reverse Reading" },
      { key: "netMeasurement", th: "Net Measurement" },
      { key: "netReading", th: "Net Reading" },
      { key: "flow", th: "Flow" },
      { key: "velocity", th: "Velocity" },
      { key: "loggerSignalValue", th: "Signal Reading" },
      { key: "loggerSignalStrength", th: "Signal Strength" },
      { key: "loggerBatteryValue", th: "Battery Reading" },
      { key: "alarmType", th: "Alarm Type" },
      { key: "alarmCode", th: "Alarm Code" },
      { key: "alarmAction", th: "Alarm Action" },
      { key: "case", th: "Case" },
      { key: "fieldActivity", th: "Field Activity" },
    ];
  }
};

export const AlarmErrorTableConstant = (role) => {
  if (role === "Admin") {
    return [
      { key: "actions", th: "" },
      { key: "customerCode", th: "Acc ID" },
      { key: "transmissionStatus", th: "Transmission Status" },
      { key: "alarmDateTime", th: "Alarm Date" },
      { key: "alarmTypeCategory", th: "Alarm Category" },
      { key: "alarmType", th: "Alarm Label" },
      { key: "region", th: "Region" },
      { key: "deviceType", th: "Alarm Type" },
      { key: "loggerSignalValue", th: "Signal Reading" },
      { key: "loggerSignalStrength", th: "Signal Strength" },
      { key: "loggerBatteryValue", th: "Battery Reading" },
      { key: "meterSerialNumber", th: "Meter S/N" },
      { key: "meterMenufacturerName", th: "Meter Manufacturer" },
      { key: "loggerSerialNumber", th: "Logger S/N" },
      { key: "loggerMenufacturerName", th: "Logger  Manufacturer" },
      { key: "installationDate", th: "Installation Date" },
      { key: "address", th: "Address" },
      { key: "acknowledged", th: "Acknowledged" },
    ];
  } else {
    return [
      { key: "actions", th: "" },
      { key: "customerCode", th: "Acc ID" },
      { key: "transmissionStatus", th: "Transmission Status" },
      { key: "alarmDateTime", th: "Alarm Date" },
      { key: "alarmTypeCategory", th: "Alarm Category" },
      { key: "alarmType", th: "Alarm Label" },
      { key: "region", th: "Region" },
      { key: "deviceType", th: "Alarm Type" },
      { key: "loggerSignalValue", th: "Signal Reading" },
      { key: "loggerSignalStrength", th: "Signal Strength" },
      { key: "loggerBatteryValue", th: "Battery Reading" },
      { key: "meterSerialNumber", th: "Meter S/N" },
      { key: "meterMenufacturerName", th: "Meter Manufacturer" },
      { key: "loggerSerialNumber", th: "Logger S/N" },
      { key: "loggerMenufacturerName", th: "Logger  Manufacturer" },
      { key: "installationDate", th: "Installation Date" },
      { key: "address", th: "Address" },
    ];
  }
};
